/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Offline_Activation_Generate_Failed_ToastInputs */



/**
* | output |
* | --- |
* | "Failed to generate offline activation code." |
*
* @param {Offline_Activation_Generate_Failed_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const offline_activation_generate_failed_toast = /** @type {((inputs?: Offline_Activation_Generate_Failed_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Offline_Activation_Generate_Failed_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Echec de la generation du code d'activation hors ligne.")
	if (locale === "de") return /** @type {LocalizedString} */ ("Es konnte kein Offline-Aktivierungscode generiert werden.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Impossibile generare il codice di attivazione offline.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Не удалось сгенерировать код активации для работы в автономном режиме.")
	if (locale === "es") return /** @type {LocalizedString} */ ("No se pudo generar el código de activación sin conexión.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("离线激活码生成失败。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("オフラインアクティベーションコードの生成に失敗しました。")
	if (locale === "hi") return /** @type {LocalizedString} */ ("ऑफलाइन सक्रियण कोड जनरेट करने में विफल।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Falha ao gerar o código de ativação offline.")
	return /** @type {LocalizedString} */ ("Failed to generate offline activation code.")
});